import { CSSProperties } from 'react';
import { LinearGradientObject, graphic } from 'echarts';

type ChartConfig = {
  showLegend?: boolean;
  colors?: LinearGradientObject[];
};

export type DataDonutChart = {
  name: string;
  value: number;
};

export type DoughnutProps = ChartConfig & {
  data: DataDonutChart[];
  subtitle?: string;
  style?: CSSProperties;
  loading?: boolean;
  center?: string[];
  radius?: string[];
};

type PercentageStatictics = {
  status: string;
  value?: string;
  percentage?: number;
};

export type StackedBarProps = ChartConfig & {
  periods: string[];
  data: Record<PercentageStatictics['status'], PercentageStatictics['value'][]>;
  loading?: boolean;
  style?: CSSProperties;
};

export enum ChartType {
  Ring = 'Ring',
  StackedBar = 'StackedBar',
  Doughnut = 'Doughnut',
}

export const STACKED_BAR_COLORS: LinearGradientObject[] = [
  new graphic.LinearGradient(0, 1, 1, 1, [
    {
      offset: 0,
      color: '#77C5E9',
    },
    {
      offset: 1,
      color: '#4C7CFC',
    },
  ]),
  new graphic.LinearGradient(0, 1, 1, 1, [
    {
      offset: 0,
      color: '#4C7CFC',
    },
    {
      offset: 1,
      color: '#7636FC',
    },
  ]),
  new graphic.LinearGradient(0, 1, 1, 1, [
    {
      offset: 0,
      color: '#77C5E9',
    },
    {
      offset: 1,
      color: '#BAFF77',
    },
    {
      offset: 1,
      color: '#3BEBDA',
    },
  ]),
  new graphic.LinearGradient(0, 1, 1, 1, [
    {
      offset: 0,
      color: '#C870E6',
    },
    {
      offset: 1,
      color: '#FF7D8F',
    },
    {
      offset: 1,
      color: '#F4A485',
    },
  ]),
];

export const DOUGHNUT_COLORS: LinearGradientObject[] = [
  new graphic.LinearGradient(0, 1, 1, 1, [
    {
      offset: 0,
      color: '#77C5E9',
    },
    {
      offset: 1,
      color: '#4C7CFC',
    },
  ]),
  new graphic.LinearGradient(0, 1, 1, 1, [
    {
      offset: 0,
      color: '#77C5E9',
    },
    {
      offset: 1,
      color: '#BAFF77',
    },
    {
      offset: 1,
      color: '#3BEBDA',
    },
  ]),
  new graphic.LinearGradient(0, 1, 1, 1, [
    {
      offset: 0,
      color: '#C870E6',
    },
    {
      offset: 1,
      color: '#7636FC',
    },
  ]),
];

export const NETWORK_COLORS: LinearGradientObject[] = [
  new graphic.LinearGradient(0, 1, 1, 1, [
    {
      offset: 0,
      color: '#77C5E9',
    },
    {
      offset: 1,
      color: '#BAFF77',
    },
    {
      offset: 1,
      color: '#3BEBDA',
    },
  ]),
];

export const DEVICES_COLORS: LinearGradientObject[] = [
  new graphic.LinearGradient(0, 1, 1, 1, [
    {
      offset: 0,
      color: '#4C7CFC',
    },
    {
      offset: 1,
      color: '#7636FC',
    },
  ]),
];
